import React, { FC, useState } from 'react'

import Avatar from '@mui/material/Avatar';
import AutoSelectAsyncList from '@pixel/core/AutoSelectAsyncList'

import useEmployeeAutocomplete, { Employee } from '../hooks/useEmployeeAutocomplete'
import { useLocalizedText } from '../contexts/Localization/localizationHooks';
import { LocalizedText } from '../contexts/Localization/LocalizationTypes';

interface EmployeeAutoCompleteProps {
    value: Array<Employee>
    onChange: (event: any, newValue: Array<Employee>) => void
    optional?: boolean
}
export const EmployeeAutoComplete: FC<EmployeeAutoCompleteProps> = ({
    value,
    onChange,
    optional = false,
}) => {
    const COMMON_TO = useLocalizedText(LocalizedText.CommonTo)
    const COMMON_OPTIONAL = useLocalizedText(LocalizedText.CommonOptional)

    const [textInput, setTextInput] = useState('')
    const [page, setPage] = useState(0)
    const [options, setOptions] = useState<Array<Employee>>([])

    const {
        employees,
        employeesCount,
        loading,
        error,
    } = useEmployeeAutocomplete({
        page,
        keywords: textInput,
        onNewResults: (response) => {
            setOptions(response.employees)
        },
        onNextPageResults: (response) => {
            setOptions(currentOptions => [...currentOptions, ...response.employees])
        }
    })

    return (
        <AutoSelectAsyncList 
            fieldLabel={COMMON_TO}
            paginated
            multiple
            placeholder={optional ? COMMON_OPTIONAL : ''}
            debounceInput={2500}
            loading={loading}
            loadingNextPage={loading}
            noResults={options.length === 0}
            options={options}
            value={value}
            inputValue={textInput}
            onDebouncedKeyStroke={(newInput: string) => {
                setPage(0)
                setTextInput(newInput)
            }}
            onChange={(event: any, newValue: Array<Employee>) => {
                if (typeof onChange === 'function') {
                    onChange(event, newValue)
                }
            }}
            onFetchNextPage={() => setPage(current => current + 1)}
            currentPage={page}
            disableCloseOnSelect={true}
            renderOption={(props, option: Employee) => (
                <div style={{ display: 'flex', alignItems: 'center' }} {...props}>
                    <div style={{padding: '5px 0'}}>
                        <span style={{color: '#1872cc', display: 'block', lineHeight: '18px'}}>{option.fullName}</span>
                        <span style={{lineHeight: '18px', display: 'block'}}>{option.email}</span>
                    </div>
                </div>
            )}
            getOptionLabel={(option: Employee) => option.fullName}
            getValueLabel={(option: Employee) => option.fullName}
            isOptionEqualToValue={(option: Employee, value: Employee) => option.EId === value.EId}
        />
    )
}

export default EmployeeAutoComplete
